import React from 'react'
import styled from "@emotion/styled/macro"
import { device } from './Theme'
import { GatsbyImage } from 'gatsby-plugin-image'

const Certifications = (props) =>{
    const CertificationsContainer = styled.div`
    text-align: center;

    @media ${device.lg} {
        margin-top: -10.625rem;
    }

    .logoContainer{
        max-width: 1380px;
        margin: 1.875rem auto;
        display: grid;
        grid-template-columns: 1fr 1fr;

        @media ${device.lg}{
            display: block;
            margin: 4.125rem auto 6.375rem auto;
        }
    }
    .logo:last-of-type{
        grid-column: 1 / span 2;
        width: 50%;
        margin: 0 auto;

        @media ${device.lg}{
            width: auto;
        }
    }
    `
    return(
        <CertificationsContainer>
        <p className="heading">
            {props.data.heading}
        </p>
        <div className="logoContainer">
        {props.data.certifications.map((certification, index) =>{
            return(
<GatsbyImage key={`certification-${index}`} className='logo' image={certification.logo} alt={certification.altText} />
        
            )
            
            
        })}
        </div>
        </CertificationsContainer>
    )
}
export {Certifications}